
import { Vue, Component, Prop } from 'vue-property-decorator'
import Building from '@/types/building'
import Uploader from '@/components/media/Uploader.vue'
import axios from 'axios'
import Filelist from '@/components/media/Filelist.vue'
import ConnectCustomer from '@/components/customers/ConnectCustomer.vue'
import ConnectTenant from '@/components/customers/ConnectTenant.vue'
import ls from '@/ls'
import { can } from '@/globalFunctions'

@Component({
  methods: { can },
  components: { ConnectTenant, ConnectCustomer, Filelist, Uploader }
})

export default class BuildingDocumentsTab extends Vue {
  @Prop({ type: Boolean, default: false }) editable!: boolean

  settings = {
    routeNames: { list: 'buildings', show: 'buildingShow', edit: 'buildingEdit' },
    routeParamKey: 'buildingId',
    functionNames: { setCurrent: 'setCurrentBuilding', save: 'saveBuilding' },
    getterNames: { current: 'currentBuilding', loading: 'loadingBuilding' }
  }

  activeTab:string = ls.get('buildingEditDrawingsActiveTab') || 'floorplans'

  directories = [
    {
      name: 'Plattegronden',
      position: 'floorplans',
      subDirectories: []
    },
    {
      name: 'Gevelaanzichten',
      position: 'facades',
      subDirectories: [
        {
          name: 'Voorgevel',
          position: 'frontFacade'
        },
        {
          name: 'Achtergevel',
          position: 'rearFacade'
        },
        {
          name: 'Linker zijgevel',
          position: 'leftFacade'
        },
        {
          name: 'Rechter zijgevel',
          position: 'rightFacade'
        }
      ]
    }
  ]

  mounted () : void {
    this.addLevelsForFloorplans()
  }

  addLevelsForFloorplans () : void {
    this.currentItem.levels.forEach((level:number) => {
      this.directories[0].subDirectories.push({
        name: this.getLevelName(level),
        position: 'floorplanLevel' + level
      })
    })
  }

  getLevelName (level:number) : string {
    if (level === 0) {
      return 'Begane grond'
    } else if (level === 90) {
      return 'Buiten'
    } else if (level === 99) {
      return 'Dak'
    } else if (level > 0) {
      return level + 'e verdieping'
    } else {
      return 'Verdieping -' + level
    }
  }

  newFileUploaded (file:File, key:string, important = false, concept = false) : void {
    const formData = new FormData()
    formData.append('position', key)
    formData.append('file', file)

    if (important) {
      formData.append('important', 'yes')
    }

    if (concept) {
      formData.append('concept', 'yes')
    }

    axios.post(process.env.VUE_APP_API_URL + '/buildings/' + this.currentItem.id + '/media', formData, { headers: { 'Content-Type': 'multipart/form-data' } }).then(() => {
      this.$store.dispatch(this.settings.functionNames.setCurrent, this.$route.params[this.settings.routeParamKey])
    })
  }

  setActiveTab (panel:string) : void {
    ls.set('buildingEditDrawingsActiveTab', panel)
    this.activeTab = panel
  }

  reloadBuilding () : void {
    this.$store.dispatch(this.settings.functionNames.setCurrent, this.$route.params[this.settings.routeParamKey])
  }

  get currentItem () : Building {
    return this.$store.getters[this.settings.getterNames.current]
  }

  get loading () : boolean {
    return this.$store.getters[this.settings.getterNames.loading].item
  }

  get saving () : boolean {
    return this.$store.getters[this.settings.getterNames.loading].save
  }
}
